<template>
  <tk-flex>
    <a-select allowClear v-model="year" style="width: 80px;" key="year">
      <template v-slot:suffixIcon>
        <span style="color: #333">年</span>
      </template>
      <a-select-option v-for="item in years" :key="item" :value="item">
        {{ item }}
      </a-select-option>
    </a-select>
    <a-select allowClear v-model="month" style="width: 70px; margin-left: 15px;" key="month">
      <template v-slot:suffixIcon>
        <span style="color: #333">月</span>
      </template>
      <a-select-option v-for="item in months" :key="item" :value="item">
        {{ item }}
      </a-select-option>
    </a-select>
    <a-select allowClear v-model="day" style="width: 70px; margin-left: 15px;" key="day">
      <template v-slot:suffixIcon>
        <span style="color: #333">日</span>
      </template>
      <a-select-option v-for="item in days" :key="item" :value="item">
        {{ item }}
      </a-select-option>
    </a-select>
  </tk-flex>
</template>
<script>
import moment from 'moment'
export default {
  name: 'StorePageSwicth',
  model: {
    prop: 'currentTime',
    event: 'change'
  },
  props: {
    currentTime: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      year: this.currentTime.year(),
      month: this.currentTime.month() + 1,
      day: this.currentTime.date(),
      years: [],
      months: [],
      days: []
    }
  },
  watch: {
    year (newV) {
      this.months = []
      this.month = ''
      if (newV) {
        this.getAllMonths()
      }
    },
    month (newV) {
      this.days = []
      this.day = ''
      if (newV) {
        this.getAllDays()
      }
    },
    day (newV) {
      if (newV) {
        this.$emit(
          'change',
          moment()
            .year(Number(this.year))
            .month(Number(this.month) - 1)
            .date(Number(this.day))
        )
      }
    }
  },
  computed: {
    storeId () {
      return this.$route.query.store
    }
  },
  mounted () {
    this.getAllTimesSelect()
  },
  methods: {
    getAllTimesSelect () {
      this.initTime()
      this.getAllYears()
      this.getAllMonths()
      this.getAllDays()
    },
    initTime () {
      this.year = this.currentTime.year()
      this.month = this.currentTime.month() + 1
      this.day = this.currentTime.date()
      this.days = [this.currentTime.date()]
      this.months = [this.currentTime.month() + 1]
      this.years = [this.currentTime.year()]
    },
    async getAllYears () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $year: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            grainstore: this.storeId
          } // 查询条件
        }
      })
      this.years = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    },
    async getAllMonths () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $month: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            date: {
              $gte: moment()
                .year(Number(this.year))
                .startOf('year')
                .toISOString(),
              $lt: moment()
                .year(Number(this.year))
                .endOf('year')
                .toISOString()
            },
            grainstore: this.storeId
          } // 查询条件
        }
      })
      this.months = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    },
    async getAllDays () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $dayOfMonth: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            date: {
              $gte: moment()
                .year(Number(this.year))
                .month(Number(this.month) - 1)
                .startOf('month')
                .toISOString(),
              $lt: moment()
                .year(Number(this.year))
                .month(Number(this.month) - 1)
                .endOf('month')
                .toISOString()
            },
            grainstore: this.storeId
          } // 查询条件
        }
      })
      this.days = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    }
  }
}
</script>
<style scoped></style>
